export enum EAgencies {
  Webcom_BY = 0,
  Webcom_RU = 1,
  Webcom_KZ = 2,
  IContext = 3,
  Digital = 4,
}

export const AGENCY_LABEL_MAP: Partial<Record<EAgencies, string>> = {
  [EAgencies.Webcom_BY]: "(WEBCOM)",
  [EAgencies.Webcom_RU]: "(WEBCOM RU)",
  [EAgencies.IContext]: "(iContext)",
};

export enum PartnershipType {
  Our_Management = 1,
  Self_Management = 2,
}

export enum ECountries {
  RU = 185,
  BY = 21,
}
export enum EAgreementStatus {
  NEW = 0,
  NOT_CONCLUDED = 1,
  ACTIVE = 2,
  AT_SIGNING = 3,
  CLOSED = 4,
  IN_CLOSING_PROCESS = 5,
  PAUSED = 6,
}

export interface INameValue<T = string> {
  name: string;
  value: T;
}

export enum EStatus {
  Active = 1,
  Inactive = 0,
}

export enum EAdvertisingService {
  Google = "google",
  Yandex = "yandex",
  FB = "fb",
  VK = "vk",
  TikTok = "tiktok",
  Mailru = "mailru",
  Snapchat = "snapchat",
  Linkedin = "linkedin",
  Twitter = "twitter",
  Market = "market",
  Vkads = "vkads",
  Telegram = "telegram",
  YBusines = "ybusiness",
  YNavigator = "ynavigator",
  Undefined = "undefined",
}
